var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['page-container']},[_c('pt-com-header',{attrs:{"name":_vm.name}}),_c('div',{staticClass:"page-main-content"},[_c('div',{staticClass:"page-left"},[_c('pt-left-menu')],1),_c('wt-view',{staticClass:"page-main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }